import { render, staticRenderFns } from "./BooleanSelector.vue?vue&type=template&id=07408d30&scoped=true"
import script from "./BooleanSelector.vue?vue&type=script&lang=js"
export * from "./BooleanSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07408d30",
  null
  
)

export default component.exports